import logo from '../../images/logo.svg';
import * as React from 'react';

export const PersonalData = () => {
return (
<div className="basic-container" style={{maxWidth:'800px'}}>
<img src={logo} className="logo" style={{marginBottom:'40px'}}/>
<h1> Согласие на обработку персональных данных  </h1>
<br />
<p>
Согласие на обработку персональных данных для пользователей программного обеспечения РТСИМ.Карьера.
Продолжая работу в программном обеспечении РТСИМ.Карьера (Далее – ПО) я выражаю свое согласие ООО «РТСИМ» (адрес: 121205, РФ, г. Москва, Территория Сколково инновационного центра, Большой бульвар, д.42, стр.1, пом.150) на автоматизированную, а также без использования средств автоматизации, обработку моих персональных данных (фамилия, имя, отчество, должность, сведения о месте обучения, адрес электронной почты, контактный телефон, сведения о действиях пользователя в ПО, сведения об оборудовании пользователя, дата и время сессии), в т.ч. с использованием метрических программ Яндекс.Метрика, Google Analytics, Firebas Google, Tune, Amplitude, Сегменто, с совершением действий: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, блокирование, удаление, уничтожение, передача (предоставление, доступ), в том числе трансграничная, партнёрам ООО «РТСИМ», предоставляющим сервис по указанным метрическим программам. Обработка персональных данных осуществляется в целях улучшения работы сайта, совершенствования продуктов и услуг компании, определения предпочтений пользователя, предоставления целевой информации по продуктам и услугам ООО «РТСИМ» и его партнёров.
</p>
<br />
<p>
Настоящее согласие действует с момента его предоставления и в течение всего периода использования сайта.
</p>
<br />
<p>
В случае отказа от обработки персональных данных метрическими программами я проинформирован о необходимости прекратить использование сайта или отключить файлы cookie в настройках браузера.
</p>
<br />
<p>
Предоставляя свои персональные данные ООО «РТСИМ» Пользователь даёт согласие на обработку, хранение и использование своих персональных данных на основании ФЗ No 152-ФЗ «О персональных данных» от 27.07.2006 г. в следующих целях:
</p>
<br />
<ul>
 <li>Осуществление клиентской поддержки,</li>
 <li>Получения Пользователем информации о маркетинговых событиях,</li>
 <li>Проведения аудита и прочих внутренних исследований с целью повышения качества предоставляемых услуг.</li>
</ul>
<br />
<p>
Под персональными данными подразумевается любая информация личного характера, позволяющая установить личность Пользователя, такая как:
</p>
<br />
<ul>
 <li>Фамилия, Имя, Отчество</li>
 <li>Дата рождения</li>
 <li>Контактный телефон</li>
 <li>Адрес электронной почты</li>
 <li>Почтовый адрес</li>
</ul>
<br />
<p>
Персональные данные Пользователей хранятся исключительно на электронных носителях и обрабатываются с использованием автоматизированных систем, за исключением случаев, когда неавтоматизированная обработка персональных данных необходима в связи с исполнением требований законодательства.
</p>
<br />
<p>
ООО «РТСИМ» обязуется не передавать полученные персональные данные третьим лицам, за исключением следующих случаев:
</p>
<br />
<ul>
 <li>По запросам уполномоченных органов государственной власти РФ только по основаниям и в порядке, установленным законодательством РФ,</li>
 <li>Стратегическим партнерам, которые работают с Компанией для предоставления продуктов и услуг, или тем из них, которые помогают Компании реализовывать продукты и услуги потребителям. Мы предоставляем третьим лицам минимальный объем персональных данных, необходимый только для оказания требуемой услуги или проведения необходимой транзакции.</li>
</ul>
<br />
<p>
Компания оставляет за собой право вносить изменения в одностороннем порядке в настоящие правила, при условии, что изменения не противоречат действующему законодательству РФ. Изменения условий настоящих правил вступают в силу после их публикации на Сайте.
</p>
</div>
)
}